import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { l3navoptions } from '../../../../Constants/Menus/ConstantMenus'
import { vitalsettings,getpatientvitalshistory } from '../../../../../../actions/RPMAction';
import './patientvitalsv2.css'

function PatientVitalsV2() {

    let [activeTop, setActiveTop] = useState(0)
    let reduxData = useSelector(state => state) ; 
    const dispatch = useDispatch();
    const patientId=localStorage.getItem('patientId') 
    let patientDetails = reduxData.rpmreducer.vitalhistory
    
    let criticalvital = localStorage.getItem("criticalvital")
    
    localStorage.removeItem("criticalvital");
    useEffect(() => {
        dispatch(getpatientvitalshistory(patientId));
        l3navoptions.map((element, key) => {
            
            if(criticalvital!=="ECG" && criticalvital!=="Temperature" && criticalvital!=="BloodPressure")
            {
                
                if(element.name==criticalvital)
                    {
                      
                        setActiveTop(key)
                    }
                    else
                    {
                        console.log(element.name)
                    }
            }
            else
            {
                
                if(criticalvital==="ECG")
                {
                    setActiveTop(4);
                }
                else if(criticalvital==="BloodPressure")
                {
                    setActiveTop(2);
                }else
                {
                    setActiveTop(3);
                }
                
            }
            
        })
   },[activeTop])




    return (
        <div className='patient-medical-container'>



            <div className="patient-medical-container_header">

                <div className="l3-nav">
                    <ul>
                        {
                            l3navoptions.map((element, key) => {
                                
                                return (
                                    <>
                                        <li
                                            key={key}
                                            className={activeTop === key ? "l2-nav-active" : null}
                                            onClick={() => { setActiveTop(key) }}
                                        >{element.name}</li>{key < l3navoptions.length - 1 ? " | " : null}
                                    </>
                                )
                            })
                        }
                    </ul>
                </div>

            </div>


            {
                l3navoptions[activeTop]?.component

            }


        </div>
    )
}

export default PatientVitalsV2